import MenuBoard from '../components/MenuBoard'
import DataStatisBoard from '../components/DataStatisBoard'
import ReleaseNotesBoard from '../components/ReleaseNotesBoard'
import EntityClout from '../components/EntityClout'
import EsgEventList from '../../esg/components/ESGEventList'
import EntityFollow from '../components/EntityFollow'

let home = {
  components: {MenuBoard,DataStatisBoard,ReleaseNotesBoard,EntityClout,EsgEventList,EntityFollow},
}
export default home



// WEBPACK FOOTER //
// ./src/home/js/home.js